import * as React from "react";
import styled from "styled-components";
import { Logo } from "./icons/Logo";

const Container = styled.div`
  display: flex;
  border-bottom: 1px solid ${(p) => p.theme.colors.grey200};
  background-color: ${(p) => p.theme.colors.white};
`;

const ScopedAuthLogo = styled.div`
  box-sizing: border-box;
  padding: 7px;
  width: 64px;
  height: 64px;
  position: relative;

  & > svg {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    padding: 8px;
    box-sizing: border-box;
  }
`;

export const NoNavigationHeader = () => (
  <Container data-id="no-nav-header">
    <ScopedAuthLogo data-id="no-nav-logolink">
      <Logo id="no-nav-logo" />
    </ScopedAuthLogo>
  </Container>
);
